import React, { useEffect } from "react";
import "./Home.css";
import bannerimg1 from "../Images/image 70.png";
import bannerimg2 from "../Images/image 71.png";
import bannerimg3 from "../Images/image 72.png";
import workimg1 from "../Images/Rectangle 4997.png";
import workimg2 from "../Images/Rectangle 4995.png";
import workimg3 from "../Images/Rectangle 5000.png";
import HomeBannerSVG from "../SVG Pics/HomeBannerSVG";
import LastSecImg from "../Images/Group 48095663.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import AOS from "aos"
import 'aos/dist/aos.css'
import Fade from "react-reveal/Fade"

function Home() {

  useEffect(() => {
    // AOS.init({duration:1800})
  }, [])

  return (
    <div>
      <div className="container-fluid home-div1">
        <HomeBannerSVG></HomeBannerSVG>
        <div className="container banner-container">
          <div className="row">
            <Fade top distance="5%" duration={1200}>

              <div className="col-lg-6 col-12">
                <h1 className="banner-head1">Powering Your Business to</h1>
                <h1 className="banner-head2">
                  Unlock <span>Full Potential</span>
                </h1>
                <p className="banner-para1">
                  Specialized in ad campaigns to provide our clients with personalised one-stop marketing solutions that drive ROI and market exposure.

                </p>
                <div className="banner-btn-div">
                  <HashLink
                    to="#our-work"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={600} className="banner-btn1">
                    SEE OUR WORK{" "}
                    <svg
                      className="ml-sm-3 ml-2"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.29289 17.7071C7.68342 18.0976 8.31658 18.0976 8.70711 17.7071L15.0711 11.3431C15.4616 10.9526 15.4616 10.3195 15.0711 9.92893C14.6805 9.53841 14.0474 9.53841 13.6569 9.92893L8 15.5858L2.34315 9.92893C1.95262 9.53841 1.31946 9.53841 0.928933 9.92893C0.538408 10.3195 0.538408 10.9526 0.928933 11.3431L7.29289 17.7071ZM7 4.37114e-08L7 17L9 17L9 -4.37114e-08L7 4.37114e-08Z"
                        fill="#22D388"
                      />
                    </svg>
                  </HashLink>
                </div>

              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>

            <div className="col-lg-6 col-12 d-flex justify-content-center banner-images-div">
              <div className="row ">
                <div className=" banner-img-1 d-lg-block d-none">
                  <img src={bannerimg1} className="img-fluid" />
                  <svg
                    className="banner-svg1"
                    width="44"
                    height="49"
                    viewBox="0 0 44 49"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.857037 3.16623C18.4788 3.16623 33.2257 19.288 35.5 36.1133"
                      stroke="url(#paint0_linear_345_66)"
                      stroke-width="5"
                    />
                    <circle
                      cx="36"
                      cy="40.1133"
                      r="6"
                      stroke="#0F6B4F"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_66"
                        x1="31.1309"
                        y1="38.6409"
                        x2="18.1237"
                        y2="1.01398"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#5AE5B3" />
                        <stop offset="1" stop-color="#2ED19E" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div className="banner-img-2 ">
                  <img src={bannerimg2} className="img-fluid" />
                  <svg
                    className="banner-svg2"
                    width="88"
                    height="82"
                    viewBox="0 0 88 82"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 30.5C15.5 30.4999 68.1778 2.93713 48.8 39.7549C39.1111 59.1327 44.763 67.2068 48.8 68.8217"
                      stroke="url(#paint0_linear_345_66)"
                      stroke-width="5"
                    />
                    <path
                      d="M85.1331 1C77.278 26.1036 69.3785 34.6747 48.7998 39.7556"
                      stroke="url(#paint1_linear_345_66)"
                      stroke-width="5"
                    />
                    <circle
                      cx="56"
                      cy="72"
                      r="8"
                      stroke="#59EEB1"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_66"
                        x1="56"
                        y1="77"
                        x2="83.5457"
                        y2="48.8721"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#59EEB1" />
                        <stop
                          offset="1"
                          stop-color="#42C099"
                          stop-opacity="0"
                        />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_345_66"
                        x1="40.5"
                        y1="52.5"
                        x2="96.8478"
                        y2="22.6081"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#6DFFC3" />
                        <stop offset="1" stop-color="#46AF84" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div className=" banner-img-1 d-lg-none d-block">
                  <img src={bannerimg1} className="img-fluid" />
                  <svg
                    className="banner-svg1"
                    width="44"
                    height="49"
                    viewBox="0 0 44 49"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.857037 3.16623C18.4788 3.16623 33.2257 19.288 35.5 36.1133"
                      stroke="url(#paint0_linear_345_66)"
                      stroke-width="5"
                    />
                    <circle
                      cx="36"
                      cy="40.1133"
                      r="6"
                      stroke="#0F6B4F"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_66"
                        x1="31.1309"
                        y1="38.6409"
                        x2="18.1237"
                        y2="1.01398"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#5AE5B3" />
                        <stop offset="1" stop-color="#2ED19E" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div className="banner-img-3">
                  <img src={bannerimg3} className="img-fluid" />
                  <svg
                    className="banner-svg3"
                    width="50"
                    height="73"
                    viewBox="0 0 53 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.5 18.5C33.6449 43.6036 21.5787 66.6747 1 71.7556"
                      stroke="url(#paint0_linear_345_66)"
                      stroke-width="5"
                    />
                    <circle
                      cx="43"
                      cy="10"
                      r="8"
                      stroke="#0F6B4F"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_66"
                        x1="1"
                        y1="71.7556"
                        x2="45.9578"
                        y2="50.5613"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#2ED19E" />
                        <stop offset="1" stop-color="#1D8665" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <svg
                    className="banner-svg4 "
                    width="77"
                    height="51"
                    viewBox="0 0 77 51"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.00009 48.0912C26.5 49 47.3749 32.9896 61.2655 16.9786"
                      stroke="url(#paint0_linear_345_66)"
                      stroke-width="5"
                    />
                    <circle
                      r="8"
                      transform="matrix(-0.455155 0.890412 0.890412 0.455155 66.479 10.4557)"
                      stroke="#0F6B4F"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_66"
                        x1="52.0458"
                        y1="33.3794"
                        x2="12.7114"
                        y2="63.7636"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#59EEB1" />
                        <stop offset="1" stop-color="#2ED19E" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
            </Fade>
          </div>
        </div>
      </div>

      {/* Section No 2 */}

      <Fade top distance="6%" duration={1200}>

        <div className="container-fluid pl-0 pr-0">
          <div className="container section2-container">
            <svg
              className="section2-svg1"
              width="97"
              height="128"
              viewBox="0 0 97 128"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 2C34.7632 30.3214 74.0789 23.7857 85 63"
                stroke="url(#paint0_linear_345_297)"
                stroke-width="5"
              />

              <circle cx="87" cy="69" r="8" stroke="#19E7A7" stroke-width="4" />
              <circle
                opacity="0.5"
                cx="33"
                cy="96"
                r="8"
                stroke="#2BAC85"
                stroke-width="4"
              />
              <circle
                opacity="0.5"
                cx="71.5"
                cy="121.5"
                r="5.5"
                stroke="#78FFD6"
                stroke-width="2"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_345_297"
                  x1="85"
                  y1="63"
                  x2="-0.499998"
                  y2="4.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#18FFB7" />
                  <stop offset="1" stop-color="#272727" />
                </linearGradient>
              </defs>
            </svg>

            <div className="container-fluid section2-div3">
              <div className="row ml-0">
                {/* <div className="section2-div3"> */}
                <div className="my-xl-0 mt-xl-2 mt-0 my-auto col-lg-2 col-12">
                  <p className="industry-para1 text-center">  When Your</p>
                  <h1 className="industry-head1 text-center">Business Matters</h1>
                </div>

                <div className="section2-div2 col-lg-8 col-12">
                  <div className="svg-div ">
                    <div className="d-flex justify-content-center">
                      <svg
                        width="55"
                        height="56"
                        viewBox="0 0 55 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="27.5" cy="17.5" r="7.5" fill="#2ED19E" />
                        <path
                          d="M25.8842 0.0657868C21.6022 0.463863 17.8797 2.19603 14.9102 5.16547C10.1871 9.8886 8.47645 17.9792 10.725 24.951C11.5104 27.3932 11.7579 27.7805 19.7517 39.314C23.8401 45.2314 27.2291 50.1051 27.2721 50.1589C27.3152 50.2019 30.7149 45.382 34.8248 39.4539C40.3764 31.4385 42.4421 28.3615 42.8832 27.4793C45.8419 21.5942 45.5514 13.9016 42.1516 8.22098C40.1504 4.88574 36.7937 2.21755 32.9958 0.95877C30.6181 0.162616 28.1005 -0.14939 25.8842 0.0657868ZM28.9075 1.92706C34.2223 2.46501 38.7625 5.53127 41.151 10.2006C42.356 12.546 42.9692 15.0206 43.0661 17.9254C43.1952 21.7018 42.3345 25.1339 40.57 27.8774C39.0961 30.1475 27.3474 47.0066 27.2721 46.9312C27.1753 46.8237 15.3083 29.6848 14.4046 28.34C12.3604 25.2952 11.4674 21.9815 11.6073 17.9147C11.7041 15.0528 12.2636 12.6966 13.404 10.4265C16.2981 4.61677 22.3984 1.27078 28.9075 1.92706Z"
                          fill="white"
                        />
                        <path
                          d="M26.4983 9.0649C23.0067 9.52087 20.2736 11.8577 19.2576 15.2633C19.0859 15.8475 19 16.5742 19 17.5431C19.0143 18.7543 19.0715 19.1533 19.4293 20.1792C20.2163 22.4021 21.6759 24.0977 23.7079 25.0809C26.1692 26.3064 28.8308 26.3064 31.2921 25.0809C33.3241 24.0977 34.7837 22.4021 35.5707 20.1792C35.9285 19.1533 35.9857 18.7543 36 17.5431C36 15.8902 35.7567 14.9213 34.9697 13.4251C33.4242 10.4756 29.8325 8.62318 26.4983 9.0649ZM29.2744 11.701C32.0934 12.5559 33.9108 15.42 33.5101 18.3696C33.1524 20.9059 31.0059 23.0433 28.3729 23.4708C25.8544 23.8698 23.1212 22.4163 22.0337 20.0795C20.4882 16.8164 22.1338 12.9122 25.5396 11.758C26.4697 11.4445 28.3157 11.416 29.2744 11.701Z"
                          fill="white"
                        />
                        <path
                          d="M15.7175 39.551C10.2413 40.2826 5.31373 41.7996 2.6025 43.6071C-0.140999 45.4361 -0.765011 47.6309 0.967161 49.4061C3.74294 52.268 10.4887 54.14 20.7204 54.8824C23.2057 55.0653 31.7912 55.0653 34.2765 54.8824C44.5081 54.14 51.2539 52.268 54.0297 49.4061C55.0303 48.3733 55.2777 47.093 54.6752 45.9418C53.3627 43.4134 48.5965 41.1864 41.9153 39.9706C38.6338 39.3789 37.9991 39.3789 37.7301 39.9706C37.5472 40.3902 37.5902 40.6484 37.913 40.9712C38.1712 41.2294 38.3541 41.2832 39.5483 41.4553C43.981 42.0686 48.2522 43.3166 50.8128 44.7583C51.8995 45.3716 53.0614 46.5012 53.1582 47.0392C53.524 48.9542 48.4136 51.1383 40.8932 52.2787C36.3745 52.9673 33.1683 53.1825 27.4984 53.1825C21.8285 53.1825 18.6224 52.9673 14.1037 52.2787C6.58327 51.1383 1.47283 48.9542 1.83863 47.0392C1.93546 46.5012 3.09741 45.3716 4.18405 44.7583C6.74465 43.3166 11.0159 42.0686 15.4485 41.4553C16.6428 41.2832 16.8257 41.2294 17.0946 40.9712C17.4067 40.6484 17.4497 40.3902 17.2668 39.9814C17.0624 39.5403 16.6535 39.4219 15.7175 39.551Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <p className="industry-head2">Local</p>
                  </div>

                  <div className="svg-div1 ">
                    <div className="d-flex justify-content-center">
                      <svg
                        width="49"
                        height="51"
                        viewBox="0 0 49 51"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.7294 0.219143C23.3091 0.448242 0.522138 22.3125 0.221915 22.7707C-0.248436 23.4779 0.0617952 24.6334 0.842377 25.0717C1.20265 25.2809 1.36276 25.3008 2.96396 25.3008H4.68524V37.2041C4.68524 45.3023 4.71526 49.2568 4.79532 49.5955C4.92542 50.2131 5.19562 50.5717 5.72601 50.8107C6.11631 50.9801 6.5166 51 12.471 51C17.6249 51 18.8658 50.9701 19.126 50.8605C19.5163 50.7012 19.9466 50.2529 20.0867 49.8744C20.1668 49.6852 20.1968 47.2945 20.1968 42.573V35.5605H24.5H28.8032V42.573C28.8032 47.2945 28.8332 49.6852 28.9133 49.8744C29.0534 50.2529 29.4837 50.7012 29.874 50.8605C30.1342 50.9701 31.3751 51 36.529 51C42.4834 51 42.8837 50.9801 43.274 50.8107C43.8044 50.5717 44.0746 50.2131 44.2047 49.5955C44.2847 49.2568 44.3148 45.3023 44.3148 37.2041V25.3008H46.0461C47.6372 25.3008 47.7974 25.2809 48.1576 25.0717C48.9382 24.6334 49.2484 23.4779 48.7781 22.7707C48.4779 22.3125 25.6909 0.448242 25.2706 0.219143C25.0504 0.0996094 24.7001 0 24.5 0C24.2999 0 23.9496 0.0996094 23.7294 0.219143ZM35.9085 12.6703L47.2369 23.5576L45.5056 23.6074C44.0045 23.6473 43.7143 23.6871 43.4241 23.8564C42.9838 24.1154 42.7236 24.474 42.6135 24.9621C42.5534 25.1812 42.5134 30.5004 42.5134 37.3236V49.3066H36.5089H30.5045V42.2941C30.5045 37.5627 30.4744 35.182 30.3944 34.9928C30.2443 34.5943 29.914 34.2656 29.4537 34.0564C29.0834 33.8871 28.7131 33.8672 24.5 33.8672C20.2869 33.8672 19.9166 33.8871 19.5463 34.0564C19.086 34.2656 18.7557 34.5943 18.6056 34.9928C18.5255 35.182 18.4955 37.5627 18.4955 42.2941V49.3066H12.4911H6.48658V37.3236C6.48658 30.5004 6.44655 25.1812 6.38651 24.9621C6.27642 24.474 6.01623 24.1154 5.5759 23.8564C5.28569 23.6871 4.99547 23.6473 3.50436 23.6074L1.76306 23.5576L13.0915 12.6703C19.3261 6.69375 24.45 1.79297 24.5 1.79297C24.54 1.79297 29.6839 6.69375 35.9085 12.6703Z"
                          fill="white"
                        />
                        <rect
                          x="20"
                          y="16"
                          width="8"
                          height="8"
                          fill="#2ED19E"
                          stroke="white"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                    <p className="industry-head2">Home</p>
                  </div>

                  <div className="svg-div1">
                    <div className="d-flex justify-content-center">
                      <svg
                        className="mx-auto"
                        width="51"
                        height="51"
                        viewBox="0 0 51 51"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M37 13.5H14.5V11L15.5 7.5L18.5 3.5L23.5 1L28.5 1.5L33 3.5L36 8L37 13.5Z"
                          fill="#2ED19E"
                        />
                        <path
                          d="M23.007 0.191748C19.4326 0.958192 16.2046 3.48049 14.5975 6.74136C13.8356 8.28818 13.3091 10.3088 13.3091 11.7023V12.3712L8.43249 12.413L3.542 12.4548L2.76618 12.845C1.36692 13.5279 0.314008 14.9353 0.00921859 16.524C-0.15703 17.388 1.9765 45.8161 2.28128 46.8333C2.8493 48.7285 4.45637 50.2614 6.45136 50.791C7.47656 51.0697 43.5248 51.0697 44.55 50.791C46.545 50.2614 48.1521 48.7285 48.7201 46.8333C49.0249 45.83 51.1446 17.388 50.9922 16.524C50.6874 14.9353 49.6345 13.5279 48.2352 12.845L47.4594 12.4548L42.5966 12.413L37.7338 12.3712L37.6507 11.2285C37.2489 5.86343 33.2451 1.30658 27.9529 0.205684C26.6644 -0.0590878 24.2538 -0.0730232 23.007 0.191748ZM28.5486 2.35173C32.6078 3.73132 35.3925 7.21516 35.7111 11.2982L35.7943 12.3852H25.5007H15.2071L15.2903 11.2982C15.6227 7.034 18.823 3.27146 23.0347 2.19844C24.4616 1.83612 27.2602 1.9058 28.5486 2.35173ZM13.3091 15.9944C13.3091 17.5134 13.2814 17.6667 13.0459 17.7503C12.8935 17.7921 12.5333 18.0847 12.2285 18.3774C11.2587 19.3668 11.1063 20.9275 11.8822 22.0424C13.3922 24.2163 16.7034 23.422 17.1328 20.8021C17.2991 19.7012 16.6341 18.3913 15.6505 17.8757L15.2487 17.6667V16.0084V14.3361H25.5007H35.7527V16.0084V17.6667L35.3509 17.8757C34.3673 18.3913 33.7023 19.7012 33.8686 20.8021C34.298 23.422 37.6091 24.2163 39.1331 22.0424C40.0613 20.7046 39.5903 18.6421 38.1772 17.8757L37.6923 17.6109V15.9805V14.3361H42.1948C47.2239 14.3361 47.307 14.3501 48.2629 15.2837C49.302 16.301 49.3158 15.3395 48.0828 31.5881C47.2516 42.6388 46.9329 46.1644 46.7667 46.5825C46.4065 47.4326 45.3951 48.422 44.5362 48.7564C43.7881 49.0351 43.5387 49.0351 25.5007 49.0351C7.4627 49.0351 7.21333 49.0351 6.46521 48.7564C5.60626 48.422 4.59491 47.4326 4.23471 46.5825C4.06846 46.1644 3.74982 42.6249 2.91857 31.5881C1.68556 15.3395 1.69941 16.301 2.73847 15.2837C3.6944 14.3501 3.72211 14.3501 8.77884 14.3361H13.3091V15.9944ZM14.8331 19.6315C15.1517 19.7988 15.318 20.4955 15.124 20.8579C14.9439 21.2062 14.2928 21.4431 13.9048 21.2899C13.0043 20.9554 13.2121 19.4922 14.1542 19.4922C14.3897 19.4922 14.6945 19.5479 14.8331 19.6315ZM37.5399 19.9381C37.9694 20.7046 37.2628 21.5686 36.4316 21.2759C35.919 21.0948 35.7111 20.7046 35.822 20.175C35.9328 19.6734 36.2376 19.4783 36.861 19.534C37.2212 19.5479 37.3875 19.6594 37.5399 19.9381Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <h1 className="industry-head2">E-Commerce</h1>
                  </div>

                  <div className="svg-div1 my-auto">
                    <div className="d-flex justify-content-center">
                      <svg
                        width="36"
                        height="51"
                        viewBox="0 0 36 51"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M35.15 10.4862V49.65H19.85V1.48615L35.15 10.4862Z"
                          stroke="white"
                          stroke-width="1.7"
                        />
                        <path
                          d="M0.85 20.4862V39.65H16.15V11.4862L0.85 20.4862Z"
                          fill="#2ED19E"
                          stroke="white"
                          stroke-width="1.7"
                        />
                        <rect
                          x="0.85"
                          y="43.85"
                          width="15.3"
                          height="5.3"
                          stroke="white"
                          stroke-width="1.7"
                        />
                      </svg>
                    </div>

                    <p className="industry-head2">Real Estate</p>
                  </div>

                  <div className="svg-div1 fitness-svg my-auto">
                    <div className="d-flex justify-content-center">
                      <svg
                        width="60"
                        height="47"
                        viewBox="0 0 60 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 38L5 10L7 6H9.5L13 7.5V37L11.5 39.5H8L5.5 38Z"
                          fill="#2ED19E"
                        />
                        <path
                          d="M47.5 38L47 10L49 6H51.5L55 7.5V37L53.5 39.5H50L47.5 38Z"
                          fill="#2ED19E"
                        />
                        <path
                          d="M15.5312 0.197123C14.1701 0.690455 12.9968 1.70061 12.4805 2.85172C12.1872 3.486 11.9526 4.64886 11.9526 5.43584C11.9526 5.68251 11.9174 5.87044 11.8704 5.84695C11.0491 5.4241 10.2982 5.15394 9.73498 5.05997C7.84593 4.75457 5.85129 5.65902 4.78357 7.30346C4.05611 8.44282 3.97398 9.05361 3.97398 13.3057V16.9939L3.01185 17.0526C1.8972 17.1114 1.4748 17.2876 0.806011 17.9806C0.0198866 18.8028 -0.0270462 19.0847 0.00815345 23.2076C0.043353 27.2364 0.0550862 27.3187 0.888143 28.1409C1.49827 28.7517 1.9324 28.9279 3.01185 28.9866L3.97398 29.0453V32.7336C3.97398 36.9856 4.05611 37.5964 4.78357 38.7358C5.85129 40.3802 7.84593 41.2847 9.73498 40.9793C10.2982 40.8853 11.0491 40.6151 11.8704 40.1923C11.9174 40.1688 11.9526 40.3567 11.9526 40.6034C11.9526 42.8821 13.0555 44.691 14.968 45.6072C15.7072 45.9596 15.848 45.9831 16.9978 45.9831C18.6053 45.9713 19.2858 45.7129 20.3535 44.7262C21.1866 43.9393 21.7263 42.9761 21.9258 41.9424C21.9962 41.5666 22.0431 38.7828 22.0431 35.165V29.0101H30.0217H38.0003V35.165C38.0003 38.8063 38.0472 41.5666 38.1176 41.9307C38.3757 43.2815 39.3613 44.7028 40.5112 45.384C41.8487 46.171 43.6674 46.2532 45.0754 45.5954C46.9996 44.7028 48.0908 42.8704 48.0908 40.5447V40.0396L48.4193 40.2628C49.2524 40.8618 50.59 41.1555 51.7281 40.991C53.8049 40.6974 55.5062 39.0999 55.9403 37.0209C56.0224 36.645 56.0694 34.9653 56.0694 32.7101V29.0101H56.8086C58.1814 29.0101 59.2256 28.411 59.7653 27.3069C59.9883 26.8723 60 26.5787 60 23.0196C60 18.7676 60 18.7323 59.1552 17.8984C58.5451 17.2876 58.111 17.1114 57.0432 17.0526L56.0694 16.9939V13.3174C56.0694 11.0622 56.0224 9.39425 55.9403 9.01838C55.5062 6.93933 53.8049 5.34187 51.7281 5.04822C50.59 4.88378 49.2524 5.17743 48.4193 5.77648L48.0908 5.99965V5.49457C48.0908 3.16886 46.9996 1.32474 45.1223 0.455535C43.6557 -0.213988 41.8722 -0.143512 40.5112 0.655217C39.3613 1.33649 38.3757 2.75775 38.1176 4.10854C38.0472 4.47267 38.0003 7.23298 38.0003 10.8742V17.0292H30.0217H22.0431V10.8742C22.0431 7.25647 21.9962 4.47267 21.9258 4.0968C21.6324 2.52283 20.3183 0.890137 18.9103 0.338075C17.9717 -0.0260517 16.3408 -0.0847817 15.5312 0.197123ZM18.2298 2.27617C18.9221 2.59331 19.6026 3.30981 19.8255 3.9441C19.9663 4.31997 19.9898 7.55013 19.9898 23.0196C19.9898 43.5164 20.0367 42.1304 19.2389 43.0231C18.0421 44.3621 15.9418 44.3739 14.7803 43.0466C13.9355 42.0834 14.0059 43.8101 14.0059 23.0196C14.0059 2.22918 13.9355 3.95585 14.7803 2.99267C15.625 2.0295 17.0682 1.7241 18.2298 2.27617ZM44.2775 2.27617C44.9228 2.56982 45.5447 3.2041 45.8498 3.86188C46.0258 4.2495 46.0375 5.97616 46.0375 23.0196C46.0375 43.8101 46.1079 42.0834 45.2631 43.0466C44.1015 44.3739 42.0013 44.3621 40.8045 43.0231C40.0066 42.1304 40.0536 43.5164 40.0536 23.0196C40.0536 2.52283 40.0066 3.90886 40.8045 3.01616C41.6962 2.0295 43.1042 1.7241 44.2775 2.27617ZM10.392 7.32695C10.8379 7.55012 11.5771 8.37234 11.7883 8.87742C12.0347 9.46472 12.0347 36.5745 11.7883 37.1618C11.5419 37.7491 10.791 38.5361 10.216 38.7828C8.58512 39.511 6.53181 38.5126 6.09768 36.7977C5.92169 36.1047 5.92169 9.92282 6.09768 9.24155C6.55528 7.44441 8.74939 6.46949 10.392 7.32695ZM52.6316 7.4679C53.1947 7.79679 53.7697 8.57203 53.9574 9.27679C54.1217 9.85234 54.1099 36.1986 53.9574 36.7859C53.4646 38.5361 51.4582 39.511 49.8273 38.7828C49.2524 38.5361 48.5015 37.7491 48.2551 37.1618C48.0087 36.5745 48.0087 9.46472 48.2551 8.87742C48.4663 8.37234 49.2055 7.55012 49.6513 7.3152C50.5078 6.8806 51.7398 6.93933 52.6316 7.4679ZM3.97398 23.0196V27.0133H3.30518C2.0028 27.0015 1.97933 26.9193 1.97933 23.0196C1.97933 19.1199 2.0028 19.0377 3.30518 19.026H3.97398V23.0196ZM38.0003 23.0196V27.0133H30.0217H22.0431V23.0196V19.026H30.0217H38.0003V23.0196ZM57.6064 19.1787C58.0288 19.5076 58.064 19.7777 58.064 23.0196C58.064 26.9193 58.0406 27.0015 56.7499 27.0133H56.0694V23.0196V19.026H56.7499C57.1136 19.026 57.5008 19.0965 57.6064 19.1787Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <p className="industry-head2">Fitness</p>
                  </div>

                  <div className="svg-div1 my-auto ">
                    <div className="d-flex justify-content-center">
                      <svg
                        width="67"
                        height="48"
                        viewBox="0 0 67 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M51 24H57.5L58.5 25L52.5 32.5L43 41L34.5 47L32 46L25.5 41L19.5 36L12.5 29.5L9.5 25H20L21 24.5L24.5 17.5L26.5 16L33.5 33L40.5 12L44.5 23.5L46.5 20.5L48.5 20L51 24Z"
                          fill="#2ED19E"
                        />
                        <path
                          d="M17.7936 0.187634C13.9315 0.881557 10.3705 3.24603 7.98774 6.70279C7.34623 7.65372 6.44289 9.58129 6.08941 10.8021C5.01587 14.503 5.48718 18.9621 7.38551 23.0614C7.63426 23.6011 7.84373 24.0637 7.84373 24.1023C7.84373 24.128 6.22033 24.1537 4.24344 24.1537H0.630069L0.315862 24.4749C-0.10308 24.8733 -0.10308 25.323 0.302771 25.7857L0.616977 26.1455L4.87186 26.184L9.12674 26.2226L9.61114 26.955C12.7663 31.6326 18.3042 37.1454 25.0596 42.3499C28.4373 44.9585 32.3911 47.5414 33.5694 47.9269C33.9883 48.0554 34.0931 48.0426 34.7738 47.6571C37.222 46.3206 42.4064 42.6711 45.6663 39.9982C51.4006 35.3078 56.1661 30.1934 58.6404 26.0812L59.3343 24.9247H62.9084H66.4825L66.7444 24.5906C67.0978 24.1408 67.0847 23.8581 66.7051 23.4212L66.3909 23.0614L63.3012 23.0228L60.2246 22.9843L60.4995 22.316C62.1229 18.371 62.4502 14.2845 61.4421 10.7892C61.0363 9.38853 59.8842 7.12686 59.007 5.98317C56.5326 2.75772 53.0371 0.663097 49.2273 0.110531C47.5778 -0.120777 44.7761 0.0205765 43.0872 0.444641C40.77 0.997211 37.353 2.42361 35.088 3.76005C34.4073 4.15841 33.8181 4.49252 33.7658 4.49252C33.7134 4.49252 33.1766 4.19696 32.5744 3.83715C29.5371 2.03809 26.0415 0.688801 23.1089 0.187634C21.695 -0.0436745 19.1421 -0.0436745 17.7936 0.187634ZM22.9125 2.2437C25.7273 2.71917 29.3538 4.20981 32.4304 6.15023C33.0326 6.53574 33.6217 6.8056 33.8181 6.8056C34.0407 6.8056 34.6167 6.52289 35.2582 6.11168C37.4708 4.67243 41.2936 3.00187 43.6764 2.41076C44.6583 2.1666 45.1688 2.1152 47.1195 2.12805C49.2273 2.12805 49.5023 2.1666 50.5758 2.48786C54.1892 3.5673 57.0694 5.98317 58.7059 9.31143C60.5126 12.9481 60.4471 17.1116 58.5357 21.7121L58.0382 22.9329L54.87 22.9714L51.7148 22.9971L50.7329 21.3651C49.031 18.4866 48.887 18.281 48.5073 18.1911C47.892 18.0369 47.4992 18.371 46.3471 20.0158C45.7318 20.8768 45.195 21.545 45.1427 21.4936C45.1034 21.4294 44.2786 18.8978 43.336 15.8651C42.3803 12.8196 41.5031 10.2367 41.3853 10.121C41.2674 9.9925 40.9794 9.864 40.7569 9.8126C39.8535 9.63269 39.9452 9.37568 36.7114 20.3499C35.088 25.8628 33.7396 30.399 33.7003 30.4247C33.6741 30.4632 33.5956 30.3733 33.5432 30.2448C32.1947 26.7109 27.1543 14.2717 26.9972 14.1046C26.7485 13.8348 26.0677 13.7962 25.7404 14.0275C25.6095 14.1175 24.3788 16.392 22.978 19.0777L20.4382 23.9609L15.3192 23.9995L10.1872 24.0252L9.61114 22.8429C6.86183 17.0859 6.97966 11.9072 9.97771 7.51237C10.7632 6.35583 12.727 4.53107 13.9708 3.7986C15.1098 3.13038 17.1259 2.3979 18.3173 2.1923C19.4563 2.01239 21.7212 2.03809 22.9125 2.2437ZM42.2755 19.5661C43.1265 22.2389 43.912 24.5263 44.0429 24.6677C44.2917 24.9375 44.8939 25.0018 45.2736 24.809C45.4045 24.7319 46.046 23.8967 46.7137 22.9457C47.3683 21.9948 47.9705 21.1724 48.036 21.1338C48.1014 21.0953 48.6513 21.892 49.2666 22.92C49.8819 23.9352 50.4711 24.7962 50.5889 24.8476C50.7067 24.8861 52.1599 24.9247 53.8095 24.9247H56.8207L56.4934 25.4644C53.4822 30.4504 46.5173 37.184 38.6752 42.6711C36.8031 43.9819 33.936 45.8709 33.8181 45.8709C33.6741 45.8709 30.9641 44.0847 29.1181 42.7868C26.9449 41.2576 24.4705 39.3686 22.3103 37.5823C20.3073 35.9375 15.7382 31.5041 14.4421 29.9363C13.3554 28.6513 11.6404 26.4153 11.6404 26.2997C11.6404 26.2611 13.8137 26.2097 16.4844 26.184C20.8178 26.1455 21.3415 26.1198 21.5379 25.927C21.6688 25.8114 22.7424 23.8324 23.9468 21.5322L26.1201 17.3558L29.4323 25.6957C31.2652 30.2962 32.8493 34.1641 32.9541 34.3183C33.4385 35.0123 34.3942 34.8709 34.7215 34.0742C34.8262 33.8043 36.2009 29.2681 37.7719 23.9738C39.3429 18.6922 40.6521 14.4387 40.6914 14.5287C40.7176 14.6315 41.4376 16.8932 42.2755 19.5661Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <p className="industry-head2">Health</p>
                  </div>
                </div>

                <div className=" my-xl-0 mt-xl-2 mt-0 my-auto col-lg-2 d-lg-block d-none  ">
                  <svg
                    className="ml-xl-3 ml-0"
                    width="92"
                    height="57"
                    viewBox="0 0 92 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M55.8869 34.5439H56.3869V34.0439V22.8089V22.3089H55.8869H34.9869V1.08789V0.587891H34.4869H22.6099H22.1099V1.08789V22.3089H1.31689H0.816895V22.8089V34.0439V34.5439H1.31689H22.1099V55.6579V56.1579H22.6099H34.4869H34.9869V55.6579V34.5439H55.8869Z"
                      stroke="#DADADA"
                    />
                    <rect
                      x="62.5"
                      y="22.5"
                      width="29"
                      height="12"
                      stroke="#DADADA"
                    />
                    <path
                      d="M61.617 2.185V14H59.662V5.143L56.245 14H54.545L51.111 5.143V14H49.173V2.185H51.519L55.429 11.62L59.271 2.185H61.617ZM68.2324 4.514C69.1391 4.514 69.9551 4.70667 70.6804 5.092C71.4057 5.47733 71.9724 6.03267 72.3804 6.758C72.7884 7.48333 72.9924 8.33333 72.9924 9.308C72.9924 10.294 72.7884 11.1497 72.3804 11.875C71.9724 12.6003 71.4057 13.1557 70.6804 13.541C69.9551 13.9263 69.1391 14.119 68.2324 14.119C67.3257 14.119 66.5097 13.9263 65.7844 13.541C65.0704 13.1557 64.5037 12.6003 64.0844 11.875C63.6764 11.1383 63.4724 10.2827 63.4724 9.308C63.4724 8.33333 63.6764 7.48333 64.0844 6.758C64.5037 6.03267 65.0704 5.47733 65.7844 5.092C66.5097 4.70667 67.3257 4.514 68.2324 4.514ZM68.2324 6.197C67.7337 6.197 67.2747 6.31033 66.8554 6.537C66.4361 6.76367 66.0961 7.115 65.8354 7.591C65.5861 8.05567 65.4614 8.628 65.4614 9.308C65.4614 9.99933 65.5861 10.5773 65.8354 11.042C66.0961 11.5067 66.4361 11.8523 66.8554 12.079C67.2747 12.3057 67.7337 12.419 68.2324 12.419C68.7311 12.419 69.1901 12.3057 69.6094 12.079C70.0287 11.8523 70.3631 11.5067 70.6124 11.042C70.8731 10.5773 71.0034 9.99933 71.0034 9.308C71.0034 8.628 70.8731 8.05567 70.6124 7.591C70.3631 7.115 70.0287 6.76367 69.6094 6.537C69.1901 6.31033 68.7311 6.197 68.2324 6.197ZM76.7936 6.469C77.111 5.857 77.5643 5.37533 78.1536 5.024C78.743 4.66133 79.423 4.48 80.1936 4.48V6.588H79.6156C78.7656 6.588 78.08 6.79767 77.5586 7.217C77.0486 7.625 76.7936 8.305 76.7936 9.257V14H74.8556V4.633H76.7936V6.469ZM90.3497 8.866C90.3497 9.18333 90.327 9.461 90.2817 9.699H83.0737C83.1077 10.6623 83.374 11.3763 83.8727 11.841C84.3713 12.3057 84.989 12.538 85.7257 12.538C86.3717 12.538 86.9157 12.3737 87.3577 12.045C87.811 11.7163 88.0887 11.28 88.1907 10.736H90.2647C90.14 11.3933 89.8793 11.977 89.4827 12.487C89.086 12.997 88.5703 13.3993 87.9357 13.694C87.301 13.9773 86.5927 14.119 85.8107 14.119C84.904 14.119 84.0993 13.9263 83.3967 13.541C82.7053 13.1557 82.1613 12.6003 81.7647 11.875C81.368 11.1497 81.1697 10.294 81.1697 9.308C81.1697 8.33333 81.368 7.48333 81.7647 6.758C82.1613 6.03267 82.7053 5.47733 83.3967 5.092C84.0993 4.70667 84.904 4.514 85.8107 4.514C86.7287 4.514 87.5277 4.70667 88.2077 5.092C88.899 5.466 89.426 5.98733 89.7887 6.656C90.1627 7.31333 90.3497 8.05 90.3497 8.866ZM88.3947 8.815C88.4173 8.203 88.3097 7.693 88.0717 7.285C87.845 6.86567 87.5277 6.55967 87.1197 6.367C86.723 6.163 86.2867 6.061 85.8107 6.061C85.0513 6.061 84.4167 6.29333 83.9067 6.758C83.3967 7.22267 83.119 7.90833 83.0737 8.815H88.3947Z"
                      fill="#6EFFD3"
                    />
                  </svg>
                </div>

                <svg
                  className="section2-svg2"
                  width="80"
                  height="67"
                  viewBox="0 0 49 67"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 7.15366C16.3407 0.694396 42.1778 -3.01968 22.8 33.7981C13.1111 53.1759 18 60.5 18 67"
                    stroke="url(#paint0_linear_345_301)"
                    stroke-width="5"
                  />
                  <circle
                    cx="-5"
                    cy="10"
                    r="8"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_345_301"
                      x1="30"
                      y1="71.043"
                      x2="51.544"
                      y2="23.4708"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#272727" />
                      <stop offset="1" stop-color="#2ED19E" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </div>

      </Fade>


      {/* Section no 3 */}



      {/* section no 4 */}

      <div className="container-fluid services-div1">
        <div className="home-color-svg"></div>
        <div className="home-color-svg1"></div>
        <div>
          <Fade top distance="5%" duration={1200}>
            <h1 className="services-text1">
              Our <span>Services</span>
            </h1>
          </Fade>
        </div>

        <div className="row services-div2">
          <Fade top distance="3%" duration={1000}>

            <div className="col-lg-6 col-12 d-sm-flex pl-0 pr-0">
              <div >
                <svg
                  className="services-svg1"
                  width="319"
                  height="238"
                  viewBox="0 0 319 238"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >

                  <path
                    className="amazon-logo-svg-path1"
                    d="M94.8666 98.6327L94.1807 97.6314L93.3291 98.4962C90.2988 101.574 87.7468 103.513 85.0352 104.692C82.3306 105.869 79.3869 106.325 75.5163 106.305C71.0042 106.283 67.071 104.857 64.2779 102.127C61.4922 99.4037 59.7391 95.2848 59.767 89.674C59.8108 80.8851 64.5411 75.0955 71.2422 72.1972L71.2431 72.1968C74.1887 70.9194 77.7556 70.1522 81.4432 69.6144C83.9295 69.2518 86.4175 68.9998 88.7841 68.76C89.9379 68.6432 91.0628 68.5292 92.1447 68.4068L93.0278 68.3069L93.0322 67.4181L93.0392 66.0088C93.0407 65.7195 93.0455 65.416 93.0505 65.1023C93.0677 64.022 93.0868 62.8209 92.9762 61.6642C92.8318 60.1549 92.4599 58.5827 91.499 57.2269C89.8626 54.8184 86.9526 53.8316 84.449 53.8192C82.1208 53.8076 79.8671 54.3807 78.0505 55.6323C76.2245 56.8904 74.8935 58.7997 74.3815 61.3415C74.2759 61.7454 74.1072 62.0973 73.9137 62.3282C73.7448 62.5298 73.6021 62.5937 73.4771 62.6035L62.8047 61.4142C62.4882 61.3118 62.2371 61.1669 62.0887 61.002C61.9695 60.8694 61.8631 60.6737 61.937 60.2707C63.187 53.9193 66.6212 49.8541 71.0167 47.3551C75.4499 44.8348 80.9067 43.886 86.1561 43.9122C91.5432 43.9391 98.3533 45.3699 102.39 49.3465L102.398 49.3539L102.406 49.3612C107.1 53.7929 107.046 59.5834 106.982 66.4442C106.976 66.9986 106.971 67.56 106.968 68.1282L106.881 85.6807C106.856 90.6336 108.697 93.2255 110.492 95.7528C110.734 96.0937 110.976 96.4335 111.211 96.7777L111.221 96.7924L111.232 96.8067C111.518 97.1936 111.643 97.5772 111.65 97.8583C111.657 98.1118 111.575 98.2498 111.443 98.344L111.423 98.3579L111.404 98.3728C109.822 99.6146 107.524 101.566 105.486 103.298C104.378 104.239 103.346 105.115 102.548 105.777C102.103 106.145 101.565 106.213 101.076 105.961C98.0978 103.449 97.1562 102.043 95.6918 99.8552C95.437 99.4747 95.1665 99.0705 94.8666 98.6327Z"
                    stroke="white"
                    stroke-width="2"
                  />
                  <path
                    className="amazon-logo-svg-path1"
                    d="M85.9108 94.0728C89.2404 91.0088 90.3143 87.4495 91.7148 83.3247L92.4975 81.0195C84.7698 78.3957 76.1032 77.3474 73.0138 86.4464C71.4485 91.0566 72.7924 95.0308 76.8977 96.4247C79.9163 97.4496 83.1906 96.5318 85.9108 94.0728Z"
                    fill="#2ED19E"
                  />
                  <path
                    className="amazon-logo-svg-path1"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M115.674 116.458C109.251 122.541 99.3214 126.577 90.4637 127.66C78.0543 129.176 66.3691 125.957 56.9658 119.375C56.2507 118.855 56.7077 117.974 57.5782 118.345C67.3411 122.538 78.982 124.329 90.6212 122.907C98.4519 121.95 106.897 119.267 114.443 114.914C115.584 114.297 116.725 115.461 115.674 116.458Z"
                    fill="#2ED19E"
                  />
                  <path
                    className="amazon-logo-svg-path1"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M118.224 112.705C117.185 111.659 112.166 112.88 109.934 113.457C109.26 113.626 109.059 113.043 109.648 112.537C113.363 109.173 120.1 109.218 120.985 110.066C121.871 110.913 121.702 117.708 118.281 121.34C117.739 121.884 117.152 121.695 117.33 121.022C117.924 118.778 119.269 113.793 118.224 112.705Z"
                    fill="#2ED19E"
                  />
                  <path
                    d="M-191.266 236.307C-216.564 130.716 -213.057 -39.5206 3.35602 124.264C117.799 207.184 175.763 179.373 190.44 155.102"
                    stroke="url(#paint0_linear_345_66)"
                    stroke-width="12"
                  />
                  <circle
                    cx="233.063"
                    cy="86.0633"
                    r="80.3219"
                    transform="rotate(-80.6396 233.063 86.0633)"
                    stroke="#414141"
                    stroke-width="10"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_345_66"
                      x1="70.8249"
                      y1="119.794"
                      x2="-147.889"
                      y2="98.8954"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#7FFFD7" />
                      <stop offset="1" stop-color="#2ED19E" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <div className="services-text-div1">
                <h1 className="services-text2">Amazon Marketing</h1>
                <p className="services-text3">
                  For more than a decade, we’ve developed a proven process to grow brands on Amazon & beyond.
                </p>
                <HashLink
                  to="/services#google-ads"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600} className="services-btn1">
                  Learn More
                  <svg
                    className="ml-sm-3 ml-2"
                    width="19"
                    height="15"
                    viewBox="0 0 19 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.2071 8.20711C18.5976 7.81658 18.5976 7.18342 18.2071 6.79289L11.8431 0.428932C11.4526 0.0384078 10.8195 0.0384078 10.4289 0.428932C10.0384 0.819457 10.0384 1.45262 10.4289 1.84315L16.0858 7.5L10.4289 13.1569C10.0384 13.5474 10.0384 14.1805 10.4289 14.5711C10.8195 14.9616 11.4526 14.9616 11.8431 14.5711L18.2071 8.20711ZM0.5 8.5L17.5 8.5V6.5L0.5 6.5L0.5 8.5Z"
                      fill="#22D388"
                    />
                  </svg>
                </HashLink>
              </div>
            </div>
          </Fade>


          <Fade top distance="3%" duration={1000}>

            <div className="col-lg-6 col-12 homesocial-div1 d-sm-flex justify-content-end pr-0 pl-0">
              <div className="services-text-div2 d-sm-block d-none" >
                <h1 className="services-text2">Amazon DSP</h1>
                <p className="services-text3">
                  Advertising on Amazon’s DSP can be a huge driver of awareness and conversions.
                </p>
                <HashLink
                  to="/services#amazon"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600} className="services-btn1">
                  Learn More
                  <svg
                    className="ml-sm-3 ml-2"
                    width="19"
                    height="15"
                    viewBox="0 0 19 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.2071 8.20711C18.5976 7.81658 18.5976 7.18342 18.2071 6.79289L11.8431 0.428932C11.4526 0.0384078 10.8195 0.0384078 10.4289 0.428932C10.0384 0.819457 10.0384 1.45262 10.4289 1.84315L16.0858 7.5L10.4289 13.1569C10.0384 13.5474 10.0384 14.1805 10.4289 14.5711C10.8195 14.9616 11.4526 14.9616 11.8431 14.5711L18.2071 8.20711ZM0.5 8.5L17.5 8.5V6.5L0.5 6.5L0.5 8.5Z"
                      fill="#22D388"
                    />
                  </svg>
                </HashLink>
              </div>
              <div>
                <div className="homeservices-svg-div2">
                  <svg
                    className="homeservices-svg-2"
                    width="274"
                    height="332"
                    viewBox="0 0 274 332"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M158.72 115.883C271.192 164.933 372.111 232.439 385.288 330.226"
                      stroke="url(#paint0_linear_345_66)"
                      stroke-width="12"
                    />
                    <circle
                      cx="86.0713"
                      cy="86.0709"
                      r="80.32"
                      transform="rotate(-83.7729 86.0713 86.0709)"
                      stroke="#414141"
                      stroke-width="10"
                    />

                    <path
                      d="M94.8666 98.6327L94.1807 97.6314L93.3291 98.4962C90.2988 101.574 87.7468 103.513 85.0352 104.692C82.3306 105.869 79.3869 106.325 75.5163 106.305C71.0042 106.283 67.071 104.857 64.2779 102.127C61.4922 99.4037 59.7391 95.2848 59.767 89.674C59.8108 80.8851 64.5411 75.0955 71.2422 72.1972L71.2431 72.1968C74.1887 70.9194 77.7556 70.1522 81.4432 69.6144C83.9295 69.2518 86.4175 68.9998 88.7841 68.76C89.9379 68.6432 91.0628 68.5292 92.1447 68.4068L93.0278 68.3069L93.0322 67.4181L93.0392 66.0088C93.0407 65.7195 93.0455 65.416 93.0505 65.1023C93.0677 64.022 93.0868 62.8209 92.9762 61.6642C92.8318 60.1549 92.4599 58.5827 91.499 57.2269C89.8626 54.8184 86.9526 53.8316 84.449 53.8192C82.1208 53.8076 79.8671 54.3807 78.0505 55.6323C76.2245 56.8904 74.8935 58.7997 74.3815 61.3415C74.2759 61.7454 74.1072 62.0973 73.9137 62.3282C73.7448 62.5298 73.6021 62.5937 73.4771 62.6035L62.8047 61.4142C62.4882 61.3118 62.2371 61.1669 62.0887 61.002C61.9695 60.8694 61.8631 60.6737 61.937 60.2707C63.187 53.9193 66.6212 49.8541 71.0167 47.3551C75.4499 44.8348 80.9067 43.886 86.1561 43.9122C91.5432 43.9391 98.3533 45.3699 102.39 49.3465L102.398 49.3539L102.406 49.3612C107.1 53.7929 107.046 59.5834 106.982 66.4442C106.976 66.9986 106.971 67.56 106.968 68.1282L106.881 85.6807C106.856 90.6336 108.697 93.2255 110.492 95.7528C110.734 96.0937 110.976 96.4335 111.211 96.7777L111.221 96.7924L111.232 96.8067C111.518 97.1936 111.643 97.5772 111.65 97.8583C111.657 98.1118 111.575 98.2498 111.443 98.344L111.423 98.3579L111.404 98.3728C109.822 99.6146 107.524 101.566 105.486 103.298C104.378 104.239 103.346 105.115 102.548 105.777C102.103 106.145 101.565 106.213 101.076 105.961C98.0978 103.449 97.1562 102.043 95.6918 99.8552C95.437 99.4747 95.1665 99.0705 94.8666 98.6327Z"
                      stroke="white"
                      stroke-width="2"
                    />
                    <path
                      d="M85.9108 94.0728C89.2404 91.0088 90.3143 87.4495 91.7148 83.3247L92.4975 81.0195C84.7698 78.3957 76.1032 77.3474 73.0138 86.4464C71.4485 91.0566 72.7924 95.0308 76.8977 96.4247C79.9163 97.4496 83.1906 96.5318 85.9108 94.0728Z"
                      fill="#2ED19E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M115.674 116.458C109.251 122.541 99.3214 126.577 90.4637 127.66C78.0543 129.176 66.3691 125.957 56.9658 119.375C56.2507 118.855 56.7077 117.974 57.5782 118.345C67.3411 122.538 78.982 124.329 90.6212 122.907C98.4519 121.95 106.897 119.267 114.443 114.914C115.584 114.297 116.725 115.461 115.674 116.458Z"
                      fill="#2ED19E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M118.224 112.705C117.185 111.659 112.166 112.88 109.934 113.457C109.26 113.626 109.059 113.043 109.648 112.537C113.363 109.173 120.1 109.218 120.985 110.066C121.871 110.913 121.702 117.708 118.281 121.34C117.739 121.884 117.152 121.695 117.33 121.022C117.924 118.778 119.269 113.793 118.224 112.705Z"
                      fill="#2ED19E"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_66"
                        x1="229.288"
                        y1="220.226"
                        x2="154.094"
                        y2="1.3341"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0.253125" stop-color="#272727" />
                        <stop offset="1" stop-color="#2ED19E" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div className="services-text-div2 d-sm-none">
                  <h1 className="services-text2">Amazon DSP</h1>
                  <p className="services-text3">
                    Advertising on Amazon’s DSP can be a huge driver of awareness and conversions.

                  </p>
                  <HashLink
                    to="/services#social-media"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={600} className="services-btn1">
                    Learn More
                    <svg
                      className="ml-sm-3 ml-2"
                      width="19"
                      height="15"
                      viewBox="0 0 19 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.2071 8.20711C18.5976 7.81658 18.5976 7.18342 18.2071 6.79289L11.8431 0.428932C11.4526 0.0384078 10.8195 0.0384078 10.4289 0.428932C10.0384 0.819457 10.0384 1.45262 10.4289 1.84315L16.0858 7.5L10.4289 13.1569C10.0384 13.5474 10.0384 14.1805 10.4289 14.5711C10.8195 14.9616 11.4526 14.9616 11.8431 14.5711L18.2071 8.20711ZM0.5 8.5L17.5 8.5V6.5L0.5 6.5L0.5 8.5Z"
                        fill="#22D388"
                      />
                    </svg>
                  </HashLink>
                </div>
              </div>
            </div>
          </Fade>

          <Fade top distance="3%" duration={1000}>

            <div className="col-12 d-sm-flex homeamazon-div1 justify-content-center pl-0 pr-0">
              <div >
                <svg
                  className="mobile-homeamzon-svg d-lg-none d-block"
                  width="317"
                  height="252"
                  viewBox="0 0 317 252"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M-88.8208 209.356C-106.97 133.605 -104.454 11.4775 50.8004 128.976C132.902 188.463 174.485 168.511 185.014 151.1"
                    stroke="url(#paint0_linear_345_1043)"
                    stroke-width="8.60878"
                  />
                  <circle
                    cx="223.274"
                    cy="93.7258"
                    r="67.9"
                    transform="rotate(-111.759 223.274 93.7258)"
                    stroke="#414141"
                    stroke-width="8.45368"
                  />

                  <g transform="translate(-9, 4)">
                    <rect
                      x="-1.36142"
                      y="0.382791"
                      width="25.1094"
                      height="83.3676"
                      rx="12.5547"
                      transform="matrix(-0.872107 -0.489316 -0.489316 0.872107 249.053 54.6478)"
                      fill="#272727"
                      stroke="white"
                      stroke-width="2"
                    />
                    <rect
                      x="215.947"
                      y="55.6478"
                      width="25.1094"
                      height="83.3676"
                      rx="12.5547"
                      transform="rotate(-29.2956 215.947 55.6478)"
                      fill="#272727"
                      stroke="white"
                      stroke-width="2"
                    />
                  </g>
                  <circle cx="195.5" cy="115.499" r="13.5" fill="#2ED19E" />

                  <defs>
                    <linearGradient
                      id="paint0_linear_345_1043"
                      x1="99.2024"
                      y1="125.769"
                      x2="-57.7025"
                      y2="110.777"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#7FFFD7" />
                      <stop offset="1" stop-color="#2ED19E" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <br className="" />
              <div className="services-text-div3" >
                <h1 className="services-text2">Google Ads</h1>
                <p className="services-text3">
                  Creating Google Ad campaigns that scale conversions
                  <br className="d-lg-block d-none"></br>while maintaining ROAS.
                </p>
                <HashLink
                  to="/services#amazon"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600} className="services-btn1">
                  Learn More
                  <svg
                    className="ml-sm-3 ml-2"
                    width="19"
                    height="15"
                    viewBox="0 0 19 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.2071 8.20711C18.5976 7.81658 18.5976 7.18342 18.2071 6.79289L11.8431 0.428932C11.4526 0.0384078 10.8195 0.0384078 10.4289 0.428932C10.0384 0.819457 10.0384 1.45262 10.4289 1.84315L16.0858 7.5L10.4289 13.1569C10.0384 13.5474 10.0384 14.1805 10.4289 14.5711C10.8195 14.9616 11.4526 14.9616 11.8431 14.5711L18.2071 8.20711ZM0.5 8.5L17.5 8.5V6.5L0.5 6.5L0.5 8.5Z"
                      fill="#22D388"
                    />
                  </svg>
                </HashLink>
              </div>
              <div>
                <svg
                  className="homeamazon-svg1 d-lg-block d-none"
                  width="431"
                  height="209"
                  viewBox="0 0 431 209"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="services-svg-line"
                    d="M1.24209 8.23987C146.285 -2.70742 195.483 33.8316 263.912 129.507"
                    stroke="url(#paint0_linear_345_266)"
                    stroke-width="12"
                  />
                  <circle
                    cx="85.3566"
                    cy="85.8696"
                    r="80.32"
                    transform="rotate(-111.759 85.3566 85.8696)"
                    stroke="#414141"
                    stroke-width="10"
                  />

                  <g transform="translate(-147.5, -01)">
                    <rect
                      x="-1.36142"
                      y="0.382791"
                      width="25.1094"
                      height="83.3676"
                      rx="12.5547"
                      transform="matrix(-0.872107 -0.489316 -0.489316 0.872107 249.053 54.6478)"
                      fill="#272727"
                      stroke="white"
                      stroke-width="2"
                    />
                    <rect
                      x="215.947"
                      y="55.6478"
                      width="25.1094"
                      height="83.3676"
                      rx="12.5547"
                      transform="rotate(-29.2956 215.947 55.6478)"
                      fill="#272727"
                      stroke="white"
                      stroke-width="2"
                    />
                  </g>
                  <circle cx="56" cy="110.499" r="13.5" fill="#2ED19E" />
                  <defs>
                    <linearGradient
                      id="paint0_linear_345_266"
                      x1="274.972"
                      y1="116.127"
                      x2="73.0562"
                      y2="-71.5636"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.122917" stop-color="#272727" />
                      <stop offset="1" stop-color="#2ED19E" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </Fade>
        </div>
      </div>

      {/* section no 5 */}


      <div className="container-fluid ">
        <div className="container">
          <div>
            <Fade top distance="6%" duration={1200}>
              <h1 className="reason-text1"  >
                We'll Be The <span> Last  <br className="d-sm-block d-none"></br>{" "}
                  Agency</span> You Ever Need
              </h1>
            </Fade>
            <Fade top distance="6%" duration={1200}>
              <p className="reason-parag2" >"We’ve put together a group of brainers & technology to deliver great results"</p>
            </Fade>
          </div>

          <div className="row reason-div2 h-100">
            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 col-12 "  >
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">Results Driven</h1>
                  <p className="reason-card-para1">
                    Can’t stop, won’t stop until we see results.
                  </p>

                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 mt-md-0 mt-4 col-12">
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">We Make It Enjoyable</h1>
                  <p className="reason-card-para1">
                    A successful collaboration that you won't regret.
                  </p>
                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>

              <div className="col-md-4 col-12 mt-md-0 mt-4" >
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">We Ship Performance</h1>
                  <p className="reason-card-para1">
                    By Holistic and modern marketing approaches that fit your needs.
                  </p>

                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>
          </div>

          <div className="row reason-div3 ">
            <Fade top distance="5%" duration={1200}>

              <div className="col-md-4 mt-md-0 mt-4 col-12" >
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">We Take Responsibility</h1>
                  <p className="reason-card-para1">
                    We’ll fire ourselves if our efforts do not achieve results.
                  </p>

                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 mt-md-0 mt-4 col-12">
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <h1 className="reason-card-text1">Increased Conversions</h1>
                  <p className="reason-card-para1">
                    By minimizing ACOS, CPA, CPC while maximizing ROAS, CTR and Quality Score.
                  </p>
                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 mt-md-0 mt-4 col-12">
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">Unified Ad Reporting</h1>
                  <p className="reason-card-para1">
                    Easily apply meaningful insights and optimizations through a customizable reporting dashboard.
                  </p>
                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>
          </div>


          <div className="row reason-div3 ">
            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 mt-md-0 mt-4 col-12">
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">Always Up-To-Date</h1>
                  <p className="reason-card-para1">
                    Our brainers, managers, and services analyze campaigns for you every week and day of the month.
                  </p>

                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 mt-md-0 mt-4 col-12">
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">Transparency</h1>
                  <p className="reason-card-para1">
                    Our services are strictly transparent. We don't apply hidden fees. And no tolerance on fake metrics.
                  </p>

                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>

            <Fade top distance="5%" duration={1200}>
              <div className="col-md-4 mt-md-0 mt-4 col-12">
                <div className="reason-card-div1">
                  <svg
                    className="reason-card-svg1"
                    width="41"
                    height="34"
                    viewBox="0 0 41 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line1"
                      d="M2.74458 20.6746C11.9694 5.43597 19.0911 3.13136 33.4457 3.11747"
                      stroke="url(#paint0_linear_345_205)"
                      stroke-width="5"
                    />
                    <circle
                      cx="7.19326"
                      cy="26.3234"
                      r="4.77212"
                      transform="rotate(-166.187 7.19326 26.3234)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_205"
                        x1="32.9048"
                        y1="1.06281"
                        x2="-0.087537"
                        y2="7.73134"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <h1 className="reason-card-text1">Experience</h1>
                  <p className="reason-card-para1">
                    With over 1,000 campaigns collectively under our belt, we have the experience to effectively plan, forecast and execute an effective ad campaign.
                  </p>

                  <svg
                    className="reason-card-svg2"
                    width="61"
                    height="26"
                    viewBox="0 0 61 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="card-svg-line2"
                      d="M2.93767 15.2223C2.93783 2.7217 10.2561 1.85389 24.2563 7.50026C38.2564 13.1466 47.9981 4.26121 49.9377 1.85415"
                      stroke="url(#paint0_linear_345_215)"
                      stroke-width="5"
                    />
                    <circle
                      cx="53.1385"
                      cy="7.88274"
                      r="5.10955"
                      transform="rotate(-72.9403 53.1385 7.88274)"
                      stroke="#A4A4A4"
                      stroke-width="4"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_345_215"
                        x1="45.6585"
                        y1="27.2303"
                        x2="46.8561"
                        y2="-9.98546"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#E8E8E8" />
                        <stop offset="1" stop-color="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      {/* </Fade> */}

      <Fade top distance="5%" duration={1200}>
        <div className="container-fluid homegrow-div">
          <div className="container grow-div1">
            <div className="row">
              <div className="col-lg-6 col-12">
                <h1 className="grow-text1">
                  Want to grow your <br className="d-xl-block d-none" />{" "}
                  business.?{" "}
                </h1>
                <div className="grow-btn-div1 mx-sm-0 mx-auto">
                  <Link to="/contact-us" className="grow-btn1">
                    {" "}
                    Let’s get started
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-12 home-grow-img-div d-flex justify-content-center">
                <img src={LastSecImg} className="img-fluid home-grow-img" />
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

export default Home;
